/** @param {object | null | undefined} program */
export function getProgramVersion(program) {
  if (!program) return 0;
  const v = program.currentVersion ?? program.playlist?.currentVersion;
  return typeof v === 'number' ? v : 0;
}

/**
 * API returns version under playlist; normalize for IDB, diff, and admin UI.
 * @param {object | null | undefined} program
 */
export function normalizeProgram(program) {
  if (!program) return program;
  const currentVersion = getProgramVersion(program);
  return { ...program, currentVersion, active: program.active ?? true };
}
